import { render } from "./Accordion.vue?vue&type=template&id=6b0fc64d&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=6b0fc64d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0fc64d"]])

export default __exports__